<template>
  <div id="contenedor-usuarios-toolbar">
    <v-toolbar
    flat
    dense>
    <div
      style="width: 350px"
      class="mr-2">
      <custom-text-field
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <!-- <filtros></filtros> -->
    <v-spacer></v-spacer>
    <!-- CUADRO DE DIALOGO AGREGAR -->
    <registrar-nuevo-usuario />
  </v-toolbar>
  </div>
</template>

<script>
// import Filtros from './Filtros.vue';
import RegistrarNuevoUsuario from '@/components/administracion/configuracion/catalogos/usuarios/Nuevo.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ToolBarUsuarios',
  components: {
    // Filtros,
    RegistrarNuevoUsuario,
    CustomTextField,
  },
  data() {
    return {
      buscarTexto: null,
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevoUsuario');
    },
  },
  watch: {
    buscarTexto: {
      handler() {
        this.$emit('buscar', this.buscarTexto);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
